<template>
    <div id="AssetTabView" class="fleet-customer-contract">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div class="btn-groups text-right mb-3 border-bottom pb-3" v-if="!disabledAdd">
            <template v-if="canAddCredit == true">
                <a href="javascript:void(0)" v-if="label == 'Add'" class="btn btn-primary" v-on:click="getCustomerEmail('create')" style="margin-right: 10px;"> Request Detail </a>
                <router-link v-if="label == 'Add'" title="Add Credit Information" class="btn btn-primary" v-bind:to="{name: 'CustomerCreditInformation',params:{id:customer_id,flag:'add'}}"  > <i class="fp-add"></i>Add</router-link>
            </template>
            <template v-if="canUpdateCredit == true">
                <a href="javascript:void(0)" v-if="label == 'Update'" class="btn btn-primary" v-on:click="getCustomerEmail('update')"> Request For Update Detail </a>
                <router-link v-if="label == 'Update'" title="Update Credit Information" class="btn btn-primary" v-bind:to="{name: 'CustomerCreditInformationUpdate',params:{id:customer_id},query:{creditId:creditId,flag:'update'}}">Update</router-link>
                <template v-if="isCreditExist == true">
                    <div class="update-detail-section">
                        <span class=" waves-effect "> Your Credit Application is already exist click on Update Button to save Credit details </span>
                        <router-link  title="Update Credit Information" class="btn btn-primary" v-bind:to="{name: 'CustomerCreditInformationUpdate',params:{id:customer_id},query:{flag:'update',creditId:creditId}}">Update</router-link>
                    </div>
                </template>
            </template>
        </div>
        <template v-if="CreaditDetailsAvailable">
            <div class="form-group form-row">
                <div class="col ml-2">
                    <label >Current Stage :</label>
                    <span class="label"  v-if="stage == 'potential'"> Pending Approval </span>
                     <span class="label"  v-else> {{ucStringValue(stage)}} </span>
                </div>
            </div>
            <!-- Credit override request block -->
            <div class="col-md-12" v-if="customerCredit.credit_override_requests.length > 0">
                <template v-for="(req , key) in customerCredit.credit_override_requests">
                    <div :key="'ovrDiv'+key" class="row form-group" v-if="req.sendTo == user_id">
                        <span class="col-md-6">
                            Credit override request sent by <label style="font-weight:bold">{{ ucStringValue(req.sentByName) }}</label> for the {{ ucStringValue(req.moduleName) }}
                            <router-link target="_blank" title="View Agreement Details" class="color-blue"  v-bind:to="{name: 'RentalAgreementView',params:{id:req.moduleId}}"><b>{{ req.moduleCode }}</b></router-link>  :
                                <template v-if="req.status == 'sent'">Received</template>
                                <template v-else>{{ ucStringValue(req.status) }}</template>
                        </span>
                        <span class="col">
                            <button v-if="req.status == 'denied' || req.status == 'sent'" class="btn btn-primary" @click="sendForApproval('approved',req.reqId)">Approve</button>
                            <button v-if="req.status == 'approved' || req.status == 'sent'" class="btn btn-warning" @click="sendForApproval('denied', req.reqId)">Deny</button>
                        </span>
                    </div>
                </template>
            </div>
            <!-- Credit override request block -->
            <div class="list-sections">
                <h5 class="ml-2"> By User </h5>
                <div class="form-row section-divider">
                    <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Contact:</label>
                            <span class="col" v-if="customerCredit.credit_contact">  {{titleCase(customerCredit.credit_contact)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Phone:</label>
                            <span class="col" v-if="customerCredit.phone">  {{titleCase(customerCredit.phone)}}</span>
                            <span class="col"  v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col">Phoneable:</label>
                            <span class="col" v-if="customerCredit.phoneable">  {{titleCase(customerCredit.phoneable)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col">Account Opened:</label>
                            <span class="col" v-if="customerCredit.account_opened">  {{titleCase(customerCredit.account_opened)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Credit Reviewed: </label>
                            <span class="col" v-if="customerCredit.credit_recieved">  {{titleCase(customerCredit.credit_recieved)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col"> Rentable: </label>
                            <span class="col" v-if="customerCredit.rentable">  {{titleCase(customerCredit.rentable)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Mailable: </label>
                            <span class="col" v-if="customerCredit.mailable">  {{titleCase(customerCredit.mailable)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> E-Mailable: </label>
                            <span class="col" v-if="customerCredit.e_mailable">  {{titleCase(customerCredit.e_mailable)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Rent For Phone: </label>
                            <span class="col" v-if="customerCredit.rent_for_phone">  {{titleCase(customerCredit.rent_for_phone)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> D & B Rating: </label>
                            <span class="col" v-if="customerCredit.e_mailable">  {{titleCase(customerCredit.e_mailable)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> D & B Pay Idx: </label>
                            <span class="col" v-if="customerCredit.d_b_pay_idx">  {{titleCase(customerCredit.d_b_pay_idx)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col"> Credit Limit: </label>
                            <span class="col" v-if="customerCredit.credit_limit">  {{titleCase(customerCredit.credit_limit)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col"> Rent For Mail: </label>
                            <span class="col" v-if="customerCredit.rent_for_mail">  {{titleCase(customerCredit.rent_for_mail)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> Credit Limit BG: </label>
                            <span class="col" v-if="customerCredit.credit_limit_bg">  {{titleCase(customerCredit.credit_limit_bg)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> Rent For Email: </label>
                            <span class="col" v-if="customerCredit.rent_for_email">  {{titleCase(customerCredit.rent_for_email)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col">Verification Document:</label>
                            <span class="col">
                                <template v-for="(doc,vkey) in customerCredit.docs">
                                    <span :key="vkey">
                                        <a href="javascript:void(0)" v-on:click="downloadDoc(doc.url ,'credit' ,doc.ext)"><span class="fileupload-preview wrappath" style="color:blue;">{{doc.display_name}}</span></a>
                                        <template v-if="customerCredit.docs.length > 1 && vkey+1 < customerCredit.docs.length "> <span :key="'e' + vkey"> | </span></template>
                                        <span v-if="!doc.url" :key="'d' + vkey">NA</span>
                                    </span>
                                </template>
                            </span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Tax Exemption: </label>
                            <span class="col" v-if="customerCredit.tax_exemption == 1">Yes</span>
                            <span class="col" v-else>No</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- <div class="row form-group">
                            <label class="col"> Dunning Level: </label>
                            <span class="col" v-if="customerCredit.dunning_level">  {{titleCase(customerCredit.dunning_level)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> Discount Lost: </label>
                            <span class="col" v-if="customerCredit.discount_lost">  {{titleCase(customerCredit.discount_lost)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> Restrictions: </label>
                            <span class="col" v-if="customerCredit.restrictions">  {{titleCase(customerCredit.restrictions)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col"> Sic: </label>
                            <span class="col" v-if="customerCredit.sic_code">  {{titleCase(customerCredit.sicCode)}} | {{titleCase(customerCredit.sicName)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Priority Code: </label>
                            <span class="col" v-if="customerCredit.priority_code">  {{titleCase(customerCredit.priority_code)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Customer Type: </label>
                            <span class="col" v-if="customerCredit.customer_type">  {{titleCase(customerCredit.customer_type)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Credit Manager </label>
                            <span class="col" v-if="customerCredit.credit_manager">  {{titleCase(customerCredit.credit_manager)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col"> Reserve To Sfx: </label>
                            <span class="col" v-if="customerCredit.reserve_to_sfx">  {{titleCase(customerCredit.reserve_to_sfx)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col"> One Time Customer: </label>
                            <span class="col" v-if="customerCredit.one_time_cust">  {{titleCase(customerCredit.one_time_cust)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col"> Last Key Code Use: </label>
                            <span class="col" v-if="customerCredit.last_key_code_use">  {{titleCase(customerCredit.last_key_code_use)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <!-- <div class="row form-group">
                            <label class="col"> Mssage Code: </label>
                            <span class="col" v-if="customerCredit.message_code">  {{titleCase(customerCredit.message_code)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col"> Reason: </label>
                            <span class="col" v-if="creditStatusReason">  {{titleCase(creditStatusReason)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-sections">
                <h5 class="ml-2"> Credit Score  </h5>
                <div class="form-row section-divider">
                    <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col"> Ansonia Risk: </label>
                            <span class="col" v-if="customerCredit.ansonia_risk_store">  {{titleCase(customerCredit.ansonia_risk_store)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col"> Ansonia DTP: </label>
                            <span class="col" v-if="customerCredit.ansonia_dtp">  {{titleCase(customerCredit.ansonia_dtp)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Ansonia High Banlance: </label>
                            <span class="col" v-if="customerCredit.ansonia_high_balance">  {{titleCase(customerCredit.ansonia_high_balance)}}</span>
                            <span class="col" v-else>-</span>
                        </div>-->
                        <div class="row form-group">
                            <label class="col">Business Start Date: </label>
                            <span class="col" v-if="customerCredit.years_in_business">  {{titleCase(customerCredit.years_in_business)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">DNB Paydex: </label>
                            <span class="col" v-if="customerCredit.dnb_paydex_score">  {{titleCase(customerCredit.dnb_paydex_score)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Paynet Master: </label>
                            <span class="col" v-if="customerCredit.paynet_master_score">  {{titleCase(customerCredit.paynet_master_score)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Credit Grade: </label>
                            <span class="col" v-if="customerCredit.credit_grade">  {{titleCase(customerCredit.credit_grade)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Full KIN : </label>
                            <span class="col" v-if="customerCredit.full_kin_score">  {{titleCase(customerCredit.full_kin_score)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Last Credit Review : </label>
                            <span class="col" v-if="customerCredit.last_credit_review">  {{titleCase(customerCredit.last_credit_review)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-sections">
                <h5 class="ml-2"> By Customer  </h5>
                <div class="form-row section-divider">
                    <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Application For :</label>
                            <span class="col">
                            <template class="customer-label-fl" v-for="(app , key) in application_for">
                                <a :key="key" v-if="app && key != 0" style="width:auto; padding:0 5px;margin-bottom:0;">|</a> <span>{{titleCase(app)}}</span>
                            </template>
                            </span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Company Name: </label>
                            <span class="col" v-if="customerCredit.company_name != 'null'">  {{titleCase(customerCredit.company_name)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Current Customer: </label>
                            <!-- <span class="col" v-if="customerCredit.which_company">  {{titleCase(customerCredit.which_company)}}</span>
                            <span class="col" v-else>-</span> -->
                            <span class="col" v-if="customerCredit.current_customer == 'yes'">  {{titleCase(customerCredit.which_company)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Social Security Name: </label>
                            <span class="col" v-if="customerCredit.social_security_name">  {{titleCase(customerCredit.social_security_name)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Social Security Number: </label>
                            <span class="col" v-if="customerCredit.social_security_number">  {{titleCase(customerCredit.social_security_number)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> DUNS #: </label>
                            <span class="col" v-if="customerCredit.duns">  {{titleCase(customerCredit.duns)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Federal Tax Id: </label>
                            <span class="col" v-if="customerCredit.federal_tx_id">  {{titleCase(customerCredit.federal_tx_id)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col"> Po Required: </label>
                            <span class="col" v-if="customerCredit.po_required">  {{titleCase(customerCredit.po_required)}}</span>
                            <span class="col" v-else>-</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col"> Credit Amount: </label>
                            <span class="col" v-if="customerCredit.credit_amount">  {{titleCase(customerCredit.credit_amount)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Billing Contact: </label>
                            <span class="col" v-if="customerCredit.billing_contact">  {{titleCase(customerCredit.billing_contact)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Billing Email: </label>
                            <span class="col" v-if="customerCredit.billing_email">  {{titleCase(customerCredit.billing_email)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Recieve Invoice Via Email: </label>
                            <span class="col" v-if="customerCredit.recive_invoice_via_email">  {{titleCase(customerCredit.recive_invoice_via_email)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Resale: </label>
                            <span class="col" v-if="customerCredit.resale">  {{titleCase(customerCredit.resale)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Resale Document:</label>
                            <span  class="col">
                                <template v-for="(doc , key) in customerCredit.resale_doc_path">
                                    <!--<a href="javascript:void(0)" v-if="doc != ''" v-on:click="downloadDoc(doc.url)"><span>{{doc.display_name}}</span></a>-->
                                    <span :key="key">
                                        <a href="javascript:void(0)" style="color:blue;" v-on:click="downloadDoc(doc.url,'resale','')">
                                            {{doc.display_name}}
                                        </a>
                                    </span>
                                </template>
                            </span>
                            <!-- <a href="javascript:void(0)" class="pull-right" v-on:click="downloadDoc(customerCredit.resale_doc_path,'resale','')"><span style="color:blue;">{{customerCredit.resale_doc_path}}</span></a> -->
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col"> Fax: </label>
                            <span class="col" v-if="customerCredit.fax">  {{titleCase(customerCredit.fax)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Owner Name: </label>
                            <span class="col" v-if="customerCredit.owner_name">  {{titleCase(customerCredit.owner_name)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Email: </label>
                            <span class="col" v-if="customerCredit.email">  {{titleCase(customerCredit.email)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> City: </label>
                            <span class="col" v-if="customerCredit.city">  {{titleCase(customerCredit.city)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> State: </label>
                            <span class="col" v-if="customerCredit.state">  {{titleCase(customerCredit.state)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Zip: </label>
                            <span class="col" v-if="customerCredit.zip">  {{titleCase(customerCredit.zip)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Partnership: </label>
                            <span class="col" v-if="customerCredit.partnership">  {{titleCase(customerCredit.partnership)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Corporation: </label>
                            <span class="col" v-if="customerCredit.corporation">  {{titleCase(customerCredit.corporation)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> DBA: </label>
                            <span class="col" v-if="customerCredit.dba">  {{titleCase(customerCredit.dba)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Business Type: </label>
                            <span class="col" v-if="customerCredit.sicCode">  {{titleCase(customerCredit.sicCode)}} | {{titleCase(customerCredit.sicName)}} </span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Business Year: </label>
                            <span class="col" v-if="customerCredit.business_year">  {{titleCase(customerCredit.business_year)}}</span>
                            <span class="col" v-else>-</span>
                        </div>
                        <div class="row form-group">
                            <label class="col"> Signature: </label>
                            <span class="col" v-if="customerCredit.signature">
                                <img :src="customerCredit.signature" height="90" alt=""/>
                            </span>
                            <span class="col" v-else>-</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="stage != 'Potential' && !notFound " class="btn-groups text-right">
                <template v-if="canChangeStage == true && !disabledAdd">
                    <button v-if="stage.toLowerCase() == 'account pending' || stage.toLowerCase() == 'credit denied'" id="creditBtn" v-on:click.prevent="creditBtnTapped('new')" class="btn btn-primary">Approve</button>
                    <button v-if="stage.toLowerCase() == 'account pending' || stage.toLowerCase() == 'new'" id="creditBtn" v-on:click.prevent="creditBtnTapped('credit denied')" class="btn btn-primary">Deny</button>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="no-data">
                No Data Available.
            </div>
        </template>
        <div class="modal fade " id="customer-email-modal" ref="approveRejectModal" data-backdrop="static" data-keyboard="false" aria-labelledby="approveRejectModal" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Customer Emails</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body ">
                        <table aria-describedby="table" class="table">
                            <tbody>
                                <tr>
                                    <td colspan="2">Notification will be send to the below mentioned email</td>
                                </tr>
                                <tr v-for="(row,key) in emailRows">
                                    <td>
                                        <input type="text" class="form-control" v-model="row.email" id="email" placeholder="Enter Email" name="email">
                                        <span class="field-error" v-if="row.emailError!=''">{{row.emailError}}</span>
                                    </td>
                                    <td>
                                        <a v-on:click="removeElement(row);" style="cursor: pointer" v-if="emailRows.length > 1">
                                            <img src="/static/images/remove-icon-small.png" alt="" >
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><button type="button" class="btn btn-primary" @click="addRow" v-if="emailRows.length < 5 ">Add Email</button></td>
                                </tr>
                            </tbody>
                        </table>
                        <br/>
                        <!--<button class="btn btn-success waves-effect" v-on:click="sendApproveOrRejectEstimate('approve')"> Approve </button>-->
                        <!--<button class="btn btn-success waves-effect" v-on:click="sendApproveOrRejectEstimate('reject')"> Reject </button>-->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-tertiary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" v-on:click="sendRequestForDetail()">Send Mail</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import {commonMixins} from '../mixins/commonMixins';

    export default {
        name: "CustomerCreditView",
        mixins:[commonMixins],
        props: {
            moduleId: {
                type: Number,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            checkCol:true,
            permissions: [],
            role:"",
            customerCredit: [],
            loading: false,
            new_used:"",
            customer_id:0,
            label:'Add',
            resalePath:"",
            creditPath:"",
            application_for:[],
            stage: 'Potential',
            creditStatusReason: '-',
            canChangeStage: false,
            canAddCredit: false,
            canUpdateCredit: false,
            notFound:false,
            googleUrl:'',
            isCreditExist:false,
            creditId:0,
            requestFor:"",
            emailRows: [],
            CreaditDetailsAvailable:false,
            disabledAdd:false,
            parentId:0,
            user_id:0,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'approve_deny_credit_application') {
                            self.canChangeStage = true;
                        }
                        if (permissions[i].name == 'add_credit_application') {
                            self.canAddCredit = true;
                            self.canUpdateCredit = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            self.user_id = userObj.id;
            // this.$root.$once('customer_credit_opted',()=>{
            var path = window.location.pathname;
            var segments = path.split("/");
            self.customer_id = segments[3];
            //This is Commnted Because Permission Check is Required For this Page
//            if (self.moduleId == undefined){
//
//                self.getPermissions();
//
//            }
            // self.customerCreditInformation(segments[3]);
            // })
            if (self.moduleId != undefined){
                self.customerCreditInformation(self.moduleId);
            }else{
                self.customerCreditInformation(segments[3]);
            }

            var path = window.location.pathname;
            var segments = path.split("/");
            self.customer_id = segments[3];
            self.resalePath = process.env.FOLDER_URL + "/resaleDoc/";
            this.creditPath =  process.env.FOLDER_URL +"/creditDoc/";
            this.googleUrl = "https://docs.google.com/viewerng/viewer?url=";
//
             self.getPermissions();

            // self.disabledAdd = false;

            if (self.$parent.parentId != undefined){
                self.parentId = self.$parent.parentId;
                if (self.parentId != undefined && self.parentId != self.customer_id){
                    self.disabledAdd = false; //to display buttons in credit tab in customer view
                }
            }


        },
        methods: {

            sendForApproval:function(flag,reqId){

                var self = this;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/user/send-notification",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        status: flag,
                        reqId:reqId
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.exDate = '';
                            self.$swal('','Credit Override request has been updated successfully.','success');
                            self.customerCreditInformation(self.customer_id);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            downloadDoc(doc_path , from , extension){
                var self = this;
                var file = "";
                if(from == 'credit'){
                    if(extension && (extension == 'png' || extension == 'jpeg' || extension == 'jpg')){
                        // file = self.creditPath+doc_path;
                        file = doc_path;
                    }else{
                        // file =  self.googleUrl+self.creditPath+doc_path;
                        file =  self.googleUrl+doc_path;
                    }
                }else{
                    //  file = self.resalePath+doc_path;
                     file = doc_path;
                }

                var save = document.createElement('a');
                save.href = file;
                save.download = file;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            customerCreditInformation(id) {

                var self = this;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/customer-credit-info/" + id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false
                        self.stage = self.ucStringValue(data.content.stage);

                        if (data.code == 200) {

                            if(data.content.flag=='exist')
                            {
                                self.isCreditExist=true;
                                self.label = 'Click here to save';

//                                alert("here")
                            }else{
                                self.label = 'Update';
                            }

                            self.creditId=data.content.id;
                            self.loading = false,
                            self.customerCredit = data.content;

                            self.application_for = data.application_for;
                            self.creditStatusReason = data.content.credit_reason;
                            self.CreaditDetailsAvailable = true;

                        }else if(data.code == 201){
                            self.notFound = true;
                            self.CreaditDetailsAvailable = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.label = 'Add';
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,false,'creditmessage');
//                        if (jqXHR.status == 0) {
//                            self.registerError = "Remote server cannot be reached";
//                        }
                    }
                });

            },
            creditBtnTapped(cust_stage) {

                var self = this;
                self.loading = true;

                this.$swal({
                    title: 'Please Enter Reason',
                    input: 'text',
                    inputPlaceholder: 'Reason',
                    showCloseButton: true,
                    confirmButtonText: 'Submit',
                    preConfirm: function (value) {
                        return new Promise(function (resolve, reject) {
                        if(value == ''){
                            self.$swal.showValidationError(
                                'please enter reason.'
                            )
                        }
                        resolve([value])
                        })
                    }
                }).then((result) => {

                    if(result.value) {
                        $.ajax({
                        url: process.env.ROOT_API + "/change-stage",
                        type: "POST",
                        data: {
                            customer_id: self.customer_id,
                            stage: cust_stage,
                            reason: result.value[0]
                        },
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            if (data.code == '200') {
                                self.customerCreditInformation(self.customer_id);
                            }
                        },
                        error: function (jqXHR, exception) {

                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'changestagecreditgemessage')
                        }

                    });
                    }else{
                        self.loading = false;
                    }

                }).catch(self.$swal.noop)
            },

            //make sentence first letter capital
            ucStringValue(data) {
                var self = this;
                var string = (data != null || data != undefined)?data.toString().trim():'';

                if(string != ''){

                    var value = string.replace(/_/g, " ");

                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;

                }else{
                    return '-';
                }

            },
            addRow: function () {
                var self = this;
                if(self.emailRows.length < 5) {
                    var index = self.emailRows.length - 1;
                    if(self.emailRows[index].email != ""){
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if(!re.test(self.emailRows[index].email)){
                            self.emailRows[index].emailError = "Email is Invalid.";

                        }else {
                            self.emailRows[index].emailError = "";
                            self.emailRows.push({email: "", emailError: ""});
                        }
                    }else{
                        self.emailRows[index].emailError = "Email is Required.";
                    }
                }
            },
            removeElement: function (row) {
                var self = this;
                if(self.emailRows.length > 1) {
                    var index = self.emailRows.indexOf(row);
                    self.emailRows.splice(index, 1);
                }
            },
            getCustomerEmail(requestFor){
                var self = this;
                self.emailRows=[];
                $("#customer-email-modal").modal("show");
                self.requestFor=requestFor;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/details",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    data: {id:self.customer_id},
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.emailRows.push({email: data.content.email,emailError:""});
                        }else{
                            self.emailRows.push({email: "",emailError:""});
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-emails');
                    }
                });
            },
            sendRequestForDetail(){
                var self = this;
                var error=false;

                for(var i=0;i<self.emailRows.length;i++)
                {
                    if(self.emailRows[i].email=="")
                    {
                        self.emailRows[i].emailError = "Email is Required.";
                        error=true;
                    }else{
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                       if(!re.test(self.emailRows[i].email)){
                           self.emailRows[i].emailError = "Email is Invalid.";
                           error=true;
                       }
                    }
                }
                if(error==false) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/creditachdetail/request",
                        type: "POST",
                        data: {
                            id: self.customer_id,
                            flag: 'credit-detail',
                            request_for: self.requestFor,
                            emails: self.emailRows,
                        },
                        // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.loading = false;

                            if (data.code == 201) {

                            }
                            if (data.status == "success") {
                                $("#customer-email-modal").modal("hide");
                                self.$swal('', 'Email has been sent to the customer', 'success');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'credit-detail-request');
                        }
                    });
                }
            },
            // strReplace(fileName){
            //     var self = this;
            //     // alert(fileName);
            //     var str = fileName;
            //     var res = str.split('+').join(' ');
            //     // var res = str.replace('+', "");
            //     return res;
            // }
        }
    };
</script>

<style scope>
    #unit_table thead tr th {
        text-align: center;
    }
    .wrappath {
        white-space: nowrap !important;
        width: 40px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomerCreditView.vue